import {
	Drawer,
	IconButton,
	Skeleton,
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Chip
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import { fetchV2VHistory, selectHistoryLoading } from "../../../slices/common";
import { useDispatch, useSelector } from "react-redux";
import { dateFormater } from "../../../utils/common/utils";
import NoDataCard from '../../../components/NoDataCard'
import { CheckGreen, ClockIcon, CrossIcon } from '../../../../assets/common-svg/CommonSvg';

// Centralized status definitions
const STATUS_MAP = {
	0: { text: "Pending", color: "#9CA3AF", bg: "#DDDDDD" },      // gray
	1: { text: "In-progress", color: "#F59E0B", bg: "#FFEDCB" }, // yellow
	2: { text: "Completed", color: "#00B278", bg: "#E4F9F2" },   // green
	3: { text: "Rejected", color: "#FF2023", bg: "#FFE3E3" },    // red
	4: { text: "Submitted", color: "#00B278", bg: "#E4F9F2" },   // green
	5: { text: "Completed", color: "#00B278", bg: "#E4F9F2" }, // green
    6: { text: "Cryopreserve LSM", color: "#9CA3AF", bg: "#DDDDDD"}
};

const HistoryDrawer = ({ open, onClose, patient_id }) => {
	const dispatch = useDispatch();
	const historyLoading = useSelector(selectHistoryLoading)
	const { role_id } = useSelector((state) => state.loginData);
	const [historyTimeline, setHistoryTimeline] = useState([]);

	useEffect(() => {
		if (open) {
			getTimeLine();
		}
	}, [open]);

	const getTimeLine = async () => {
		try {
			const res = await dispatch(
				fetchV2VHistory({ portal_type: role_id == 5 ? 1 : 2, patient_id })
			).unwrap();
			if (res?.status === 200) {
				setHistoryTimeline(res?.data || []);
			}
		} catch (err) {
			console.error(err);
		}
	};

	const renderSkeleton = () => (
		<div className="space-y-6">
			{Array.from({ length: 4 }).map((_, i) => (
				<div key={i} className="relative pl-8">
					<Skeleton variant="circular" width={12} height={12} className="absolute left-[1px] top-1" />
					<div className="mb-3">
						<Skeleton variant="rectangular" width={120} height={24} sx={{ borderRadius: "4px" }} />
					</div>
					<div className="border rounded-md flex gap-2 flex-col bg-[#F0F1F5] p-3">
						<Skeleton variant="text" width="40%" />
						<Skeleton variant="text" width="60%" />
						<Skeleton variant="text" width="50%" />
					</div>
				</div>
			))}
		</div>
	);

	const renderSteps = (steps) => (
		<div className="space-y-6">
			{steps?.reverse()?.map((section, idx) => {
				const statusInfo = STATUS_MAP[section.status] || STATUS_MAP[0];

				if (section.status == 0)
					return null

				return (
					<div key={idx} className="relative pl-8 ">
						{/* Vertical line */}
						{idx !== steps.length - 1 && (
							<div
								className="absolute left-1.5 top-0 h-[118%] mt-1 w-0.5"
								style={{ backgroundColor: statusInfo.color }}
							/>
						)}

						{/* Dot */}
						<span
							className="absolute left-[1px] top-1 w-3 h-3 rounded-full border-2 border-white shadow"
							style={{ backgroundColor: statusInfo.color }}
						/>


						{/* Task status */}
						<div className=" flex gap-2 flex-col p-3 border rounded-md bg-[#FFFFFF] ">
							{/* Section pill */}
							<div className="mb-3">
								<span
									className="text-xs font-medium p-2 rounded"
									style={{
										backgroundColor: statusInfo.bg,
										color: statusInfo.color,
									}}
								>
									{section.name}
								</span>
							</div>
							<div>
								<span className="text-gray-700 text-sm">Task Status</span>:{" "}
								<span
									className="font-semibold"
									style={{ color: statusInfo.color }}
								>
									{statusInfo.text}
								</span>
							</div>
							{!section.rejected_by_name && <hr />}
							{section.completed_date && section.creator_name &&
								<div className="flex justify-between text-sm mr-4">
									{(section.completed_date && !section.rejected_by_name) && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed On:{" "}
											</span>
											{dateFormater(section.completed_date)}
										</div>
									)}
									{(section.creator_name && !section.rejected_by_name) && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed By:{" "}
											</span>
											{section.creator_name}
										</div>
									)}
								</div>
							}


							{section?.partially_approved_by_name && <>
								<hr />
								<div>
									<span className="font-semibold">{section?.partially_approved_by_role}</span>
								</div>
								<div className="flex justify-between text-sm mr-4">
									{section?.partially_approved_at && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed On:{" "}
											</span>
											{dateFormater(section?.partially_approved_at)}
										</div>
									)}
									{section?.partially_approved_by_name && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed By:{" "}
											</span>
											{section?.partially_approved_by_name}
										</div>
									)}
								</div>
							{((section?.partially_approved_by_role == 'Manufacture' && section?.mf_remarks) ||  (section?.partially_approved_by_role == 'QC Lead' &&  section?.qc_remarks) || (section?.partially_approved_by_role == 'Quality Check' && section?.qc_remarks)) ?
						<div className="flex text-sm gap-2">
							<span className="text-gray-700">Remarks:</span>
                            <span>{section?.partially_approved_by_role == 'Manufacture' ? section?.mf_remarks: section?.partially_approved_by_role == 'QC Lead'? section?.qc_remarks : section?.partially_approved_by_role == 'Quality Check'?  section?.qc_remarks:'' }
                           </span> </div>
						:''}
							</>}
							

							{section?.completed_by_name && <>
								<hr />
								<div>
									<span className="font-semibold">{section?.completed_by_role}</span>
								</div>
								<div className="flex justify-between text-sm mr-4">
									{section?.completed_at && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed On:{" "}
											</span>
											{dateFormater(section?.completed_at)}
										</div>
									)}
									{section?.completed_by_name && (
										<div>
											<span className="text-gray-700 text-sm">
												Completed By:{" "}
											</span>
											{section?.completed_by_name}
										</div>
									)}
								</div>
							{((section?.completed_by_role == 'Manufacture' && section?.mf_remarks) ||  (section?.completed_by_role == 'QC Lead' &&  section?.qc_remarks) || (section?.completed_by_role == 'Quality Check' && section?.qc_remarks)) ?
						<div className="flex text-sm gap-2">
							<span className="text-gray-700">Remarks:</span>
                            <span>{section?.completed_by_role == 'Manufacture' ? section?.mf_remarks: section?.completed_by_role == 'QC Lead'? section?.qc_remarks : section?.completed_by_role == 'Quality Check'?  section?.qc_remarks:'' }
                           </span> </div>
						:''}
							</>}

								{section?.approved_by_name && <>
								<hr />
								<div>
									<span className="font-semibold">{section?.approved_by_role}</span>
								</div>
								<div className="flex justify-between text-sm mr-4">
									{section?.approved_at && (
										<div>
											<span className="text-gray-700 text-sm">
									Completed at:{" "}
											</span>
											{dateFormater(section?.approved_at)}
										</div>
									)}
									{section?.approved_by_name && (
										<div>
											<span className="text-gray-700 text-sm">
									Completed By:{" "}
											</span>
											{section?.approved_by_name}
										</div>
									)}
								</div>
					{((section?.approved_by_role == 'Manufacture Lead' && section?.mf_lead_remarks) || (section?.approved_by_role == 'Quality Analyst' && section?.qa_remarks) || (section?.approved_by_role == 'Quality Check' && section?.qc_remarks)) ?
			
						<div className="flex text-sm gap-2">
							<span className="text-gray-700">Remarks:</span>
<span>{section?.approved_by_role == 'Manufacture Lead' ? section?.mf_lead_remarks : section?.approved_by_role == 'Quality Analyst'? section?.qa_remarks: section?.approved_by_role == 'Quality Check'?  section?.qc_remarks: '' }
</span> </div> :''}
							</>}

						{section?.submitted_by_name && <>
								<hr />
								<div>
									<span className="font-semibold">{section?.submitted_by_role}</span>
								</div>
								<div className="flex justify-between text-sm mr-4">
									{section?.submitted_at && (
										<div>
											<span className="text-gray-700 text-sm">
									Submitted On:{" "}
											</span>
											{dateFormater(section?.submitted_at)}
										</div>
									)}
									{section?.submitted_by_name && (
										<div>
											<span className="text-gray-700 text-sm">
									Submitted By:{" "}
											</span>
											{section?.submitted_by_name}
										</div>
									)}
								</div>
					{((section?.submitted_by_role == 'Manufacture Lead' && section?.mf_lead_remarks) || (section?.submitted_by_role == 'Quality Analyst' && section?.qa_remarks) || (section?.submitted_by_role == 'Quality Check' && section?.qc_remarks)) ?
			
						<div className="flex text-sm gap-2">
							<span className="text-gray-700">Remarks:</span>
<span>{section?.submitted_by_role == 'Manufacture Lead' ? section?.mf_lead_remarks : section?.submitted_by_role == 'Quality Analyst'? section?.qa_remarks: section?.submitted_by_role == 'Quality Check'?  section?.qc_remarks: '' }
</span> </div> :''}
							</>}

							
 
							{section?.rejected_by_name && <>
								<hr />
								<div>
									<span className="font-semibold">{section?.rejected_by_role}</span>
								</div>
								<div className="flex justify-between text-sm mr-4">
									{section?.rejected_at && (
										<div>
											<span className="text-gray-700 text-sm">
												Rejected On:{" "}
											</span>
											{dateFormater(section?.rejected_at)}
										</div>
									)}
									{section?.rejected_by_name && (
										<div>
											<span className="text-gray-700 text-sm">
												Rejected By:{" "}
											</span>
											{section?.rejected_by_name}
										</div>
									)}
								</div>
						<div className="flex text-sm gap-2">
							<span className="text-gray-700">Remarks:</span>
                           <span>{section?.reason}</span></div>
							</>}
				
							
						</div>
					</div>
				);
			})}
		</div>
	);

	return (
		<Drawer
			anchor="right"
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: {
					width: 780,
					boxShadow: "0px 0px 20px rgba(0,0,0,0.15)",
				},
			}}
		>
			<div className="p-2 relative h-full bg-white overflow-y-auto">
				{/* Header */}
				<div className="flex justify-between items-center border-b pb-3">
					<h2 className="text-lg font-semibold">
						Vein-To-Vein History
					</h2>
					<IconButton onClick={onClose}>
						<CloseIcon />
					</IconButton>
				</div>

				{/* Timeline with Accordions */}
				<div className="relative mt-6 ml-2 border border-gray-300 rounded-md p-4 vein-t-vein">
					{historyLoading ? renderSkeleton() : (
						historyTimeline?.length > 0 ? (
							<div className="relative">
								
								{historyTimeline?.reverse()?.map((cycle, idx) => {
									const cycleStatusInfo = STATUS_MAP[cycle?.currentStatus] || STATUS_MAP[0];
									return (
										<div key={`_div_key_${idx}`} className="relative pl-8 mb-6">
											{/* Date */}
											<span key={`_date_key_${idx}`} className={`relative date_follow`} style={{ backgroundColor: cycleStatusInfo?.bg, color: cycleStatusInfo?.color }}>
												{cycle.updated_at ? dateFormater(cycle?.updated_at) : ''}</span>
											{idx !== historyTimeline.length - 1 && (<span key={`_border_key_${idx}`} className={`absolute left-[11px] h-[calc(100%+25px)] top-2 text-sm font-medium w-0.5`} style={{backgroundColor:cycleStatusInfo?.color}}>
											</span>)}
											
											{/* Dot */}
											<span key={`_bot_key_${idx}`}
												className={`absolute left-[6px] top-2 w-3 h-3 rounded-full border-2 border-[#fff] shadow z-10`}
												style={{ backgroundColor: cycleStatusInfo?.color }}
											/>
											{/* Accordion */}
											<Accordion defaultExpanded className="bg-[#F5F6FA] mt-3">
												<AccordionSummary expandIcon={<ExpandMoreIcon />}>
													<div className="flex items-center justify-between w-full">
														<div className="flex flex-col gap-2 mt-4">
															<h1 className="font-bold">{cycle.cycle || `Cycle ${idx + 1}`} - {cycle?.currentStep}</h1>
															<p><span className="text-[#7b7b7d]">Batch Id : </span><span>{cycle?.batch_no}</span></p>
															<p><span className="text-sm d-flex flex gap-2" style={{ color: cycleStatusInfo.color }}>
																{cycle?.currentStatus == 4 || cycle?.currentStatus == 2 || cycle?.currentStatus == 5 ? <CheckGreen Filled={cycleStatusInfo.color} Width={18} Height={18} />:
															cycle?.currentStatus == 3 ? <CrossIcon /> : <ClockIcon Filled={cycleStatusInfo.color} />}{cycleStatusInfo.text}</span></p>
														</div>
														<div> 
															<Chip 
																label={cycle.status == 1 ? "Active" : "In-Active"} 
																color={cycle.status == 1 ? "success" : "error"} 
															/>
														</div>
													</div>
												</AccordionSummary>
												<AccordionDetails>
													{cycle.data?.length > 0 ? renderSteps(cycle.data) : <NoDataCard heading="No Steps Available" />}
												</AccordionDetails>
											</Accordion>
										</div>
									);
								})}
							</div>
						) : <NoDataCard heading="No Data to Display" />
					)}
				</div>
			</div>
		</Drawer>
	);
};

export default HistoryDrawer;